<template>
  <div id="sig-to-copy" style="background:#ffffff;background-color:#ffffff;max-width:600px;">
    <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
      <tbody>
        <tr>
          <td style="direction:ltr;font-size:0px;padding:0;text-align:left;vertical-align:top;width:600px;">
            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
              <tr>
                <td align="left" style="font-size:0px;padding:0px;word-break:break-word;width:600px;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                    <tbody>
                      <tr>
                        <td style="vertical-align:top;padding:0;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                            <tr>
                              <td align="left" style="font-size:0px;padding:5px 10px 5px 0;word-break:break-word;">
                                <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:16px;font-weight:bold;line-height:1;text-align:left;color:#d82532;">{{
                                  formData.firstName }} {{ formData.lastName }}</div>
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style="font-size:0px;padding:0 10px 0 0;word-break:break-word;">
                                <div style="font-family:helvetica;font-size:12px;line-height:16px;text-align:left;color:#515151;">{{
                                  formData.titlePosition }}</div>
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style="font-size:0px;padding:0 10px 0 0;word-break:break-word;">
                                <div style="font-family:helvetica;font-size:12px;line-height:16px;text-align:left;color:#515151;">
                                  <span v-if="!formData.authorizedDealer">{{ formData.address }}</span>
                                  <span v-if="formData.authorizedDealer">{{ formData.authorizedDealerText }}</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style="font-size:0px;padding:0 10px 0 0;word-break:break-word;">
                                <div style="font-family:helvetica;font-size:12px;line-height:16px;text-align:left;color:#515151;">
                                  <span v-if="formData.phone"><strong>p:</strong>&nbsp;<a :href="'tel:' + formData.phone" style="color: #515151">{{
                                    formData.phone }}&nbsp;</a></span><span v-if="formData.fax"><strong>f:&nbsp;</strong>{{ formData.fax
                                  }}&nbsp;</span><span v-if="formData.email"><strong>e:&nbsp;</strong><a :href="'mailto:' + formData.email" style="color: #515151;">{{
                                    formData.email }}</a></span></div>
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style="font-size:0px;padding:5px 10px 5px 0;word-break:break-word;">
                                <table cellpadding="0" cellspacing="0" width="100%" border="0" style="cellspacing:0;color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;table-layout:auto;width:100%;">
                                  <tr>
                                    <td style="padding: 0 0 5px 0;"><a :href="'https://' + formData.website.selectedVal" style="color: #d82532"><strong><span v-if="formData.website.selectedVal == null">website.com</span>{{ formData.website.selectedVal }}</strong></a></td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'signature-nologo-nosocial',
  props: ['formData']
}
</script>